import actionCreator from '../../shared/decorators/actionCreator';
import { REDUX_NAMESPACE } from '../constants';

const ACTION_CREATORS = {
  @actionCreator(REDUX_NAMESPACE)
  finishLoadingCreativeFields() {},

  @actionCreator(REDUX_NAMESPACE)
  loadCreativeFields() {},

  @actionCreator(REDUX_NAMESPACE)
  setContentSelectorsById(contentSelectorsById) {
    return { contentSelectorsById };
  },

  @actionCreator(REDUX_NAMESPACE)
  setCreativeFieldsByContentType(creativeFieldsByContentType) {
    return { creativeFieldsByContentType };
  },

  @actionCreator(REDUX_NAMESPACE)
  setCreativeFieldsById(creativeFieldsById) {
    return { creativeFieldsById };
  },

  @actionCreator(REDUX_NAMESPACE)
  setScrapedCreativeContent(scrapedCreativeContent) {
    return { scrapedCreativeContent };
  },

  @actionCreator(REDUX_NAMESPACE)
  setSourceContent(sourceContent) {
    return { sourceContent };
  },

  @actionCreator(REDUX_NAMESPACE)
  setSourceContentUrl(sourceContentUrl) {
    return { sourceContentUrl };
  },

  @actionCreator(REDUX_NAMESPACE)
  startLoadingCreativeFields() {},

  @actionCreator(REDUX_NAMESPACE)
  updateContentSelector(contentSelector) {
    return { contentSelector };
  },

  @actionCreator(REDUX_NAMESPACE)
  updateContentSelectors(contentSelectors) {
    return { contentSelectors };
  },

  // update ONE creative Field
  @actionCreator(REDUX_NAMESPACE)
  updateCreativeField(creativeField) {
    return { creativeField };
  },

  // update multiple creative fields
  @actionCreator(REDUX_NAMESPACE)
  updateCreativeFields(creativeFields) {
    return { creativeFields };
  },

  @actionCreator(REDUX_NAMESPACE)
  updateCreativeFieldWithContent(elementId) {
    return { elementId };
  },

  @actionCreator(REDUX_NAMESPACE)
  updateCreativeFieldsWithContent() {},
};

export default ACTION_CREATORS;
